import { useState } from 'react'
import { IconSvg } from 'components/common'
import { ContentModal } from 'components/organisms/modals/content-modal'

interface LocationRestrictModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	message?: string
}

export function LocationRestrictModal({ open, setOpen, message }: LocationRestrictModalProps) {
	return (
		<ContentModal
			open={open}
			setOpen={setOpen}
			isModal
			className="z-50"
			hideCloseButton={false}
		>
			<div className="relative flex flex-col items-center space-y-5">
				<div className="max-w-[400px] text-center">
					<div className="flex justify-center mb-4">
						<div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center">
							<IconSvg icon="location" width={32} height={32} className="text-red-500" />
						</div>
					</div>
					<h3 className="text-2xl font-bold mb-4">Location Restricted</h3>
					<div className="text-lg text-primary-text mb-2">{message}</div>
					<div className="text-sm text-secondary-text italic mt-4">
						Please make sure you are within the allowed area and have location services enabled.
					</div>
				</div>
				<button
					type="button"
					className="px-6 rounded-3xl text-center transition-all duration-300 bg-primary text-white font-bold block w-full h-10 shadow-button backdrop-blur-lg hover:bg-primary-hover"
					onClick={() => setOpen(false)}
				>
					OK
				</button>
			</div>
		</ContentModal>
	)
}

export interface LocationRestrictModalManagedProps {
	message?: string
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'location-restrict': LocationRestrictModalManagedProps
	}
}

export function ManagedLocationRestrictModal({
	onClose,
	...rest
}: LocationRestrictModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<LocationRestrictModal
			open={open}
			setOpen={(v: boolean) => {
				if (!v) handleClose()
			}}
			{...rest}
		/>
	)
}
